
export interface ShopAdapterModel {
    BaseURI: string;
    imagePath: string;

}


export class localhost implements ShopAdapterModel
{


   BaseURI: string = "http://localhost:5001/api";
 //BaseURI: string = "http://192.168.1.13:5001/api";

   imagePath: string = "http://localhost:4200/";

}

export class OrthoCentre implements ShopAdapterModel
{

   BaseURI: string = "http://192.168.1.190:5001/api";
   imagePath: string = "http://192.168.1.190/OrthoCentre/";

}

export class OrthoCentreTest implements ShopAdapterModel
{

   BaseURI: string = "http://192.168.1.190:8001/api";
   imagePath: string = "http://192.168.1.190/TryWestClinic/";

}

export class WestClinic implements ShopAdapterModel{

    BaseURI: string = "https://wcms.marvel-solution.com.hk:5263/api";
    imagePath: string = "https://wcms.marvel-solution.com.hk/WestClinic/";
}

export class WestClinicOffice implements ShopAdapterModel{

  BaseURI: string = "https://westernmc.marvel-solution.com.hk:5263/api";
  imagePath: string = "https://westernmc.marvel-solution.com.hk:5881/WestClinic/";
}
export class TryWestClinic29 implements ShopAdapterModel{

  BaseURI: string = "https://wcms.marvel-solution.com.hk:5260/api";
  imagePath: string = "https://wcms.marvel-solution.com.hk/TryWestClinic/";
}

export class eyecentre29 implements ShopAdapterModel{

  BaseURI: string = "https://wcms.marvel-solution.com.hk:5301/api";
  imagePath: string = "https://wcms.marvel-solution.com.hk/eyecentre29/";
}

export class OfficeDemo implements ShopAdapterModel {
  BaseURI: string = "http://westernmc.marvel-solution.com.hk:5260/api";
  imagePath: string = "http://westernmc.marvel-solution.com.hk/TryWestClinic/";
}


